export var BodyType;
(function (BodyType) {
    BodyType["convertible"] = "Convertible";
    BodyType["coupe"] = "Coupe";
    BodyType["estate"] = "Estate";
    BodyType["hatchback"] = "Hatchback";
    BodyType["mpv"] = "MPV";
    BodyType["pickup"] = "Pickup";
    BodyType["pickupDoubleCab"] = "Pickup Double Cab";
    BodyType["saloon"] = "Saloon";
    BodyType["suv"] = "SUV";
    BodyType["combiVan"] = "Combi Van";
    BodyType["minibus"] = "Minibus";
    BodyType["carDerivedVan"] = "Car Derived Van";
    BodyType["camper"] = "Camper";
    BodyType["limousine"] = "Limousine";
    BodyType["panelVan"] = "Panel Van";
    BodyType["hearse"] = "Hearse";
    BodyType["windowVan"] = "Window Van";
})(BodyType || (BodyType = {}));
